import styled from "@emotion/styled";
import {ReactComponent as orangeTeleSvg} from "../../../../images/800CallLogs/Resources for Call Logs/TelephoneOrange.svg"

export const TelephoneOrangeSvg = styled(orangeTeleSvg)`
     width: 50.53px;
     height: 49.47px;
`;